import { memoize } from 'es-toolkit/compat'

export default memoize
